// extracted by mini-css-extract-plugin
export default {"text":"HomeLocationBodyText_text__6EY2U"};